"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'TableSteps_1_0_0',
  categories: []
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;